import { getAccessToken, hasSession } from "./authSession";

let registration = null;
let started = false;

const worker = () =>
  navigator.serviceWorker.controller ||
  registration?.active ||
  registration?.waiting ||
  null;

const post = (message) => {
  worker()?.postMessage(message);
};

const logoutUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  if (!apiUrl) {
    return "";
  }
  return `${apiUrl.replace(/\/+$/, "")}/logout?scope=browser`;
};

// Other open tabs share the session cookies. Logout runs only when the
// closing document was the last one, and a refresh cancels it.
export const startTabSessionGuard = () => {
  if (started || typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  started = true;

  const cancel = () => post({ type: "CANCEL_LOGOUT" });

  cancel();

  window.addEventListener("pageshow", cancel);

  window.addEventListener("pagehide", (event) => {
    if (event.persisted || (!hasSession() && !getAccessToken())) {
      return;
    }
    post({ type: "SCHEDULE_LOGOUT", logoutUrl: logoutUrl() });
  });

  const workerUrl = `${process.env.PUBLIC_URL || ""}/session-worker.js`;
  navigator.serviceWorker
    .register(workerUrl)
    .then((next) => {
      registration = next;
      cancel();
    })
    .catch(() => {
      // Browser close still drops the session cookies.
    });
};
